export default __webpack_public_path__ + "static/media/creditCard.7aee1a43.svg";